/* eslint-disable @typescript-eslint/no-explicit-any */

export const ToggleSwitch = ({
  defaultState = false,
  checkedState = undefined,
  onChangeHandler = () => null,
  isDisabled = false,
  id = "switch",
}: $TSMigrationFixMe) => {
  let checkStatus = defaultState
  const handleClick = () => {
    onChangeHandler(!checkStatus)
    checkStatus = !checkStatus
  }

  return (
    <label
      className='tw-relative tw-inline-flex tw-cursor-pointer tw-items-center tw-mb-0'
      onChange={() => (!isDisabled ? handleClick() : undefined)}
    >
      <input
        id={`switch-${id}`}
        type='checkbox'
        className='tw-peer tw-sr-only'
        defaultChecked={checkStatus}
        checked={checkedState}
        disabled={isDisabled}
      />
      <label
        htmlFor={`switch-${id}`}
        className='tw-hidden tw-mb-0'
      />
      <div className="tw-peer tw-h-6 tw-w-11 tw-rounded-full tw-bg-slate-200 after:tw-absolute after:tw-left-0.5 after:tw-top-0.5 after:tw-h-5 after:tw-w-5 after:tw-rounded-full after:tw-border after:tw-border-gray-300 after:tw-bg-white after:tw-transition-all after:tw-content-[''] peer-checked:tw-bg-secondary peer-checked:after:tw-translate-x-full peer-checked:after:tw-border-secondary peer-disabled:tw-opacity-30 peer-disabled:tw-cursor-not-allowed" />
    </label>
  )
}
